<script lang="ts">
    import type {PaymentRequest} from './loadPaymentRequest'
    import PaymentRequestPage from "./PaymentRequestPage.svelte";
    import {onMount} from "svelte";
    import {prepareStripeCheckout} from "./prepareStripeCheckoutFunctions";
    import {environmentId, tenantId} from "../stores";
    import type {Environment} from "@docsndata/stripe-types";
    import {loadStripe} from "@stripe/stripe-js";
    import {StripePaymentForm} from "@docsndata/thesmartwashltd-booking-components";

    export let paymentRequest: PaymentRequest
    let loaded = false
    let errorMessage = null
    let clientSecret = null
    let stripe = null

    onMount(async () => {
        await prepareStripeCheckout(paymentRequest, $tenantId, $environmentId as Environment, {
            "bookingRecordId": paymentRequest.booking._recordId,
            "bookingModelId": paymentRequest.booking._modelId,
            "email": paymentRequest.customer.email,
            "paymentRequestCode": paymentRequest.code.toString()
        })
            .then(async response => {
                stripe = await loadStripe(response.publicKey)
                clientSecret = response.clientSecret
            })
            .catch((error: any) => errorMessage = error.message)
            .finally(() => loaded = true)
    })

    function paymentComplete() {
        alert("thanks")
    }
</script>

{#if loaded}
    {#if errorMessage}
        <div class="mt-5 margin-auto text-center">
            <h2 class="text-danger">{errorMessage}</h2>
        </div>
    {:else}
        <PaymentRequestPage {paymentRequest}/>
        {#if stripe && clientSecret}
            <StripePaymentForm {stripe} {clientSecret} on:paymentComplete={paymentComplete}/>
        {/if}
    {/if}
{:else}
    <div class="mt-5 margin-auto text-center">
        <h2>Preparing checkout screen...</h2>
    </div>
{/if}

